// w31 Buklama — variant that renders the standalone HTML at
// /templates/buklama.html (layered paper-diorama / tunnel-book wedding
// invitation — midnight + cream + gold + sage, Cinzel + Cormorant
// Garamond; a 3D perspective hero with translateZ depth layers, scroll +
// damped pointer parallax, and pop-up hinge ornaments) inside a
// full-bleed iframe.
//
// The HTML's customizer accepts DD.MM.YYYY directly, so unlike nikoh /
// wedding-is-coming no ISO conversion is needed here — names/date/time/
// venue/address pass through raw.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/buklama.html";

export function BuklamaStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) params.set("date", t.date);
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (ctx.slug) params.set("slug", ctx.slug);
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Buklama"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#0d2a52",
      }}
    />
  );
}
